/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */
import { IDescriptorBody } from '../../descriptor';
import Message, { IMessage } from './../../message';

export interface IGetDocumentDetailsResponse extends IMessage {
	lastDocumentSessionId?: string;
	lastDocumentSessionOperationId?: string;
	currentDocumentSessionId?: string;
	currentDocumentSessionVersion?: number;
	currentDocumentSessionOperationId?: string;
}

export interface ICurrentDocumentSession {
	lastOperationId?: string;
	version?: number;
	id?: string;
}

export interface ILastDocumentSession {
	id?: string;
	lastOperationId?: string;
}

export default class GetDocumentDetailsResponse extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'GetDocumentDetailsResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {

		fields: {
			lastDocumentSessionId: {
				type: 'string',
				id: 1
			},
			lastDocumentSessionOperationId: {
				type: 'string',
				id: 2
			},
			currentDocumentSessionId: {
				type: 'string',
				id: 3
			},
			currentDocumentSessionVersion: {
				type: 'uint32',
				id: 4
			},
			currentDocumentSessionOperationId: {
				type: 'string',
				id: 5
			}
		}
	};

	public constructor(
		public readonly lastDocumentSession?: ILastDocumentSession,
		public readonly currentDocumentSession?: ICurrentDocumentSession
	) {
		super();
	}

	public get data(): IGetDocumentDetailsResponse {
		return {
			lastDocumentSessionId: this.lastDocumentSession?.id,
			lastDocumentSessionOperationId: this.lastDocumentSession?.lastOperationId,
			currentDocumentSessionId: this.currentDocumentSession?.id,
			currentDocumentSessionVersion: this.currentDocumentSession?.version,
			currentDocumentSessionOperationId: this.currentDocumentSession?.lastOperationId
		};
	}

	public toJSON(): IGetDocumentDetailsResponse {
		return {
			lastDocumentSessionId: this.lastDocumentSession?.id,
			lastDocumentSessionOperationId: this.lastDocumentSession?.lastOperationId,
			currentDocumentSessionId: this.currentDocumentSession?.id,
			currentDocumentSessionVersion: this.currentDocumentSession?.version,
			currentDocumentSessionOperationId: this.currentDocumentSession?.lastOperationId
		};
	}

	public static fromJSON( data: IGetDocumentDetailsResponse ): GetDocumentDetailsResponse {
		const lastDocumentSession: ILastDocumentSession | undefined = data.lastDocumentSessionId ? {
			id: data.lastDocumentSessionId,
			lastOperationId: data.lastDocumentSessionOperationId
		} : undefined;

		const currentDocumentSession: ICurrentDocumentSession | undefined = data.currentDocumentSessionId ? {
			lastOperationId: data.currentDocumentSessionOperationId,
			version: data.currentDocumentSessionVersion,
			id: data.currentDocumentSessionId
		} : undefined;

		return new GetDocumentDetailsResponse( lastDocumentSession, currentDocumentSession );
	}
}
